export const DEFAULT_PHONE_COUNTRY_CODE = "+261";
export const KAJIKAJY_PHONE_COUNTRIES = [
    { flag: "🇲🇬", code: "+261", name: "Madagascar" },
    { flag: "🇷🇪", code: "+262", name: "La Réunion / Mayotte" },
    { flag: "🇲🇺", code: "+230", name: "Maurice" },
    { flag: "🇰🇲", code: "+269", name: "Comores" },
    { flag: "🇸🇳", code: "+221", name: "Sénégal" },
    { flag: "🇨🇮", code: "+225", name: "Côte d'Ivoire" },
    { flag: "🇧🇫", code: "+226", name: "Burkina Faso" },
    { flag: "🇳🇪", code: "+227", name: "Niger" },
    { flag: "🇧🇯", code: "+229", name: "Bénin" },
    { flag: "🇲🇱", code: "+223", name: "Mali" },
    { flag: "🇬🇳", code: "+224", name: "Guinée" },
    { flag: "🇬🇼", code: "+245", name: "Guinée-Bissau" },
    { flag: "🇸🇱", code: "+232", name: "Sierra Leone" },
    { flag: "🇱🇷", code: "+231", name: "Liberia" },
    { flag: "🇹🇬", code: "+228", name: "Togo" },
    { flag: "🇬🇭", code: "+233", name: "Ghana" },
    { flag: "🇳🇬", code: "+234", name: "Nigeria" },
    { flag: "🇨🇲", code: "+237", name: "Cameroun" },
    { flag: "🇨🇫", code: "+236", name: "Centrafrique" },
    { flag: "🇨🇩", code: "+243", name: "Congo RDC" },
    { flag: "🇨🇬", code: "+242", name: "Congo Brazzaville" },
    { flag: "🇬🇦", code: "+241", name: "Gabon" },
    { flag: "🇬🇶", code: "+240", name: "Guinée Équatoriale" },
    { flag: "🇹🇩", code: "+235", name: "Tchad" },
    { flag: "🇰🇪", code: "+254", name: "Kenya" },
    { flag: "🇹🇿", code: "+255", name: "Tanzanie" },
    { flag: "🇺🇬", code: "+256", name: "Ouganda" },
    { flag: "🇷🇼", code: "+250", name: "Rwanda" },
    { flag: "🇧🇮", code: "+257", name: "Burundi" },
    { flag: "🇪🇹", code: "+251", name: "Éthiopie" },
    { flag: "🇸🇴", code: "+252", name: "Somalie" },
    { flag: "🇩🇯", code: "+253", name: "Djibouti" },
    { flag: "🇲🇿", code: "+258", name: "Mozambique" },
    { flag: "🇿🇲", code: "+260", name: "Zambie" },
    { flag: "🇿🇼", code: "+263", name: "Zimbabwe" },
    { flag: "🇲🇦", code: "+212", name: "Maroc" },
    { flag: "🇩🇿", code: "+213", name: "Algérie" },
    { flag: "🇹🇳", code: "+216", name: "Tunisie" },
    { flag: "🇱🇾", code: "+218", name: "Libye" },
    { flag: "🇪🇬", code: "+20", name: "Égypte" },
    { flag: "🇿🇦", code: "+27", name: "Afrique du Sud" },
    { flag: "🇦🇴", code: "+244", name: "Angola" },
    { flag: "🇫🇷", code: "+33", name: "France" },
    { flag: "🇧🇪", code: "+32", name: "Belgique" },
    { flag: "🇨🇭", code: "+41", name: "Suisse" },
    { flag: "🇱🇺", code: "+352", name: "Luxembourg" },
    { flag: "🇬🇧", code: "+44", name: "Royaume-Uni" },
    { flag: "🇩🇪", code: "+49", name: "Allemagne" },
    { flag: "🇮🇹", code: "+39", name: "Italie" },
    { flag: "🇪🇸", code: "+34", name: "Espagne" },
    { flag: "🇵🇹", code: "+351", name: "Portugal" },
    { flag: "🇺🇸", code: "+1", name: "États-Unis / Canada" },
    { flag: "🇭🇹", code: "+509", name: "Haïti" },
    { flag: "🇨🇳", code: "+86", name: "Chine" },
    { flag: "🇮🇳", code: "+91", name: "Inde" }
];
export function getPhoneCountry(code) {
    return (KAJIKAJY_PHONE_COUNTRIES.find((country) => country.code === code) ??
        KAJIKAJY_PHONE_COUNTRIES[0]);
}
export function onlyPhoneDigits(value) {
    return value.replace(/\D/g, "");
}
export function formatMalagasyLocalPhone(value) {
    const digits = onlyPhoneDigits(value).slice(0, 9);
    let formatted = "";
    for (let index = 0; index < digits.length; index += 1) {
        if (index === 2 || index === 4 || index === 7) {
            formatted += " ";
        }
        formatted += digits[index];
    }
    return formatted;
}
export function formatLocalPhoneForCountry(value, countryCode) {
    if (countryCode === DEFAULT_PHONE_COUNTRY_CODE) {
        return formatMalagasyLocalPhone(value);
    }
    return value.replace(/[^\d\s\-().]/g, "");
}
export function buildInternationalPhoneNumber(countryCode, localNumber) {
    const trimmed = localNumber.trim();
    return trimmed ? `${countryCode} ${trimmed}` : "";
}
//# sourceMappingURL=phone.js.map